export const PREMIUM_MODAL_CONTENT_LOC_KEY = 'premiumModalSituationsContent';
export const SITUATIONS_LIMIT = 10;
